import React from "react";
import styled from "styled-components";

interface HeaderSliderProps {
  tabs: string[];
  setActiveTab: (tab: string) => void; // Accepting setActiveTab function as a prop
  activeTab: string; // Accept activeTab as a required prop
}

const HeaderSlider: React.FC<HeaderSliderProps> = ({ tabs, setActiveTab, activeTab }) => {
  return (
    <TabWrapper>
      {tabs.map((tab) => (
        <div
          key={tab}
          className={`tab ${activeTab === tab ? "tab-active" : ""}`}
          onClick={() => setActiveTab(tab)} // Use the setActiveTab prop
        >
          {tab}
        </div>
      ))}
    </TabWrapper>
  );
};

export default HeaderSlider;
export const TabWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 20px;
  background: #eaecf0;
  display: flex;
  width: 254px;
  padding: 4px;
  justify-content: space-between;
  align-items: center;
  .tab {
    padding: 4px 13px;
    border-radius: 20px;
    cursor: pointer;
    background-color: transparent;
    color: #546881;
    font-weight: 500;
  }

  .tab-active {
    background-color: #164781;
    color: #fff;
  }

  .tab:hover {
    padding: 4px 13px;
  }
`;
